module.exports = __webpack_public_path__ + "static/img/three_img.42ceb63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/riff/three_img.png
// module id = e4Bg
// module chunks = 12